import * as React from 'react';
import {RouterProvider} from 'react-router';
import {router} from './router';
import {SnackbarProvider} from './contexts/SnackbarContext';
import {CssBaseline, ThemeProvider} from '@mui/material';
import theme from './theme/theme';
import {Provider} from './contexts/Context';
import StartupTokenCleanup from './core/StartupTokenCleanup';

export const Root: React.FC = () => (
    <React.StrictMode>
        <Provider>
            <ThemeProvider theme={theme}>
                <SnackbarProvider>
                    <CssBaseline/>
                    <StartupTokenCleanup/>
                    <RouterProvider router={router}/>
                </SnackbarProvider>
            </ThemeProvider>
        </Provider>
    </React.StrictMode>
);
